import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { Brand, BrandCreate, BrandFilter } from '../data/brand';

export function createBrandService(client: AxiosInstance) {
  return createCrudService<Brand, BrandCreate, BrandFilter>(client,
    "/master-data/ProductBrand",
    "brandId",
  );
}

export type BrandService = CrudService<Brand, BrandCreate, BrandFilter>;
